var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.13801 15.3038V9.6898C3.13801 7.53663 4.90807 5.79117 7.06121 5.79117H4.8C2.64683 5.79117 0.901367 7.53663 0.901367 9.6898V15.3038C0.901367 17.457 2.64683 19.2025 4.8 19.2025H7.06121C4.90807 19.2025 3.13801 17.457 3.13801 15.3038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.697 10.8232C11.078 10.4417 11.0783 9.82429 10.6978 9.44425C10.3172 9.06421 9.6998 9.06544 9.31879 9.44699C8.93778 9.82854 8.93742 10.4459 9.318 10.826C9.69857 11.206 10.316 11.2048 10.697 10.8232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3022 20H4.69789C2.11824 20 0.0195312 17.9013 0.0195312 15.3216V9.7076C0.0195312 7.12795 2.11824 5.02924 4.69789 5.02924H15.3022C17.8818 5.02924 19.9805 7.12795 19.9805 9.7076V15.3216C19.9805 17.9013 17.8818 20 15.3022 20ZM4.69789 6.58869C2.97813 6.58869 1.57899 7.98783 1.57899 9.7076V15.3216C1.57899 17.0414 2.97813 18.4405 4.69789 18.4405H15.3022C17.0219 18.4405 18.4211 17.0414 18.4211 15.3216V9.7076C18.4211 7.98783 17.0219 6.58869 15.3022 6.58869H4.69789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91 14.7368H8.08936C5.74616 14.7368 3.83984 12.8305 3.83984 10.4873C3.83984 10.0567 4.18893 9.70758 4.61957 9.70758C5.05021 9.70758 5.3993 10.0567 5.3993 10.4873C5.3993 11.9706 6.60604 13.1774 8.08936 13.1774H11.91C13.3933 13.1774 14.6001 11.9706 14.6001 10.4873C14.6001 10.0567 14.9492 9.70758 15.3798 9.70758C15.8104 9.70758 16.1595 10.0567 16.1595 10.4873C16.1595 12.8305 14.2532 14.7368 11.91 14.7368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9246 3.46979C12.4939 3.46979 12.1448 3.1207 12.1448 2.69006C12.1448 2.06667 11.6377 1.55945 11.0142 1.55945H8.98693C8.3635 1.55945 7.85633 2.06667 7.85633 2.69006C7.85633 3.1207 7.50725 3.46979 7.0766 3.46979C6.64596 3.46979 6.29688 3.1207 6.29688 2.69006C6.29688 1.20674 7.50362 0 8.98693 0H11.0142C12.4975 0 13.7043 1.20674 13.7043 2.69006C13.7043 3.1207 13.3552 3.46979 12.9246 3.46979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon1);
export default __webpack_public_path__ + "static/media/project-icon1.b959adbfb9d2a89ec1dd6da647048928.svg";
export { ForwardRef as ReactComponent };